// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
/* 路由 */
import router from './router'
import store from './store'

import axios from "axios"

//  axios.defaults.baseURL = "/api";
axios.interceptors.response.use((res) => res.data);



/* swiper */
import 'swiper/dist/css/swiper.min.css';
/* 重置样式 */
import './assets/css/reset.min.css'
/* jquery */
import 'jquery'
/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'
/* animate.css */
import 'animate.css'
/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)
/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)
/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)
/* 时间 */
import dayjs from "dayjs"
Vue.prototype.$dayjs = dayjs;
import vueLazy from 'vue-lazyload'
Vue.use(vueLazy,{
  preLoad: 0,//
  error: require('./assets/img/drawing/iov-img.png'),
  loading: require('./assets/img/drawing/Loading.png'),
  attempt: 5
})

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import { i18n } from '@/lang'


Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value), // 这里会根据选的语言切换Element-ui的语言
})
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    next();
});


new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js